import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet";

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState('');
  const [isCreatingUser, setIsCreatingUser] = useState(false);
  const [message, setMessage] = useState("");

  const navigate = useNavigate();

  // Handle submit
  const handleSubmit = async (e) => {
      e.preventDefault();
      setMessage("Opretter bruger...");
    
      try {
        const res = await fetch("https://matly-backend.onrender.com/api/user/register/", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ username, email, password }),
        });
    
        const data = await res.json();
        if (res.ok) {
          setMessage("bruger oprettet - logger ind...");
        } else {
          setMessage(`⚠️ ${data.error}`);
          return; // Stop here if registration failed
        }
    
        // 🧠 If register is successful, immediately log in:
        const tokenRes = await fetch("https://matly-backend.onrender.com/api/token/", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username,
            password,
          }),
        });
    
        const tokenData = await tokenRes.json();
        localStorage.setItem("access", tokenData.access);
        localStorage.setItem("refresh", tokenData.refresh);
    
        // 🔁 Redirect or update UI
        navigate("/home");
      } catch (err) {
        console.error(err);
        alert("Noget gik galt: " + err.message);
      }
    };

  // Handle login
  const handleLogin = async (e) => {
      e.preventDefault();
      try {
          const response = await fetch("https://matly-backend.onrender.com/api/token/", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ username, password }),
          });
    
          const data = await response.json();
          if (response.ok) {
              console.log("🎉 Login success!", data);
              
              // Store tokens in localStorage
              localStorage.setItem("access", data.access);
              localStorage.setItem("refresh", data.refresh);
              
              // Redirect to profile page
              navigate('/home');
          } else {
            setMessage("⚠️ ukendt brugernavn eller adgangskode");
          }
      } catch (error) {
          console.error("⚠️ Error:", error);
      }
  };

  return (
    <div 
        className="loginBackground"
        style={{ backgroundImage: "url('/images/matly_background.png')" }}
    >
      <Helmet>
        <title>login | matly</title>
      </Helmet>
      {/* White overlay */}
      <div className="absolute inset-0 bg-white opacity-2       0"></div>

      {/* Content */}
      <div className="relative z-10">
        {/* Header */}
        <header className ="sticky top-0 relative z-20 bg-rose-50/30 backdrop-blur-sm pt-8">
          <div className="flex items-center justify-center">  
            <h1 className="text-4xl font-nunito">
              <div className="flex mr-2 gap-2">
                <img
                    src="/images/logo.png"
                    alt="Logo"
                    className="h-12 w-12 rounded-lg"
                />
                <span className="font-bold relative top-[3px]">matly</span>
              </div>
            </h1>
          </div>
        </header>

        {/* Login Form */}
        <div className="justify-center m-6">
          <div className="max-w-md mx-auto mt-32 p-6 bg-white rounded-2xl shadow">
              <h2 className="text-2xl mb-4 font-bold font-nunito text-center">velkommen</h2>
              {message && <div className="text-rose-400 font-nunito text-center mb-4">{message}</div>}
              
              {isCreatingUser ? (
                  // opret bruger
                  <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                      <input
                      type="text"
                      placeholder="brugernavn"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      className="border p-2 rounded-lg"
                      />
                      <input
                      type="password"
                      placeholder="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="border p-2 rounded-lg"
                      />
                      <input
                          type="email"
                          placeholder="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          className="w-full border p-2 rounded"
                      ></input>

                      <button
                          type="submit"
                          className="bg-blue-500 font-nunito text-white p-2 rounded-lg">
                      opret bruger
                      </button>
                  </form>
              ) : (
                  // login
                  <form onSubmit={handleLogin} className="flex flex-col gap-4">
                      <input
                      type="text"
                      placeholder="brugernavn"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      className="border p-2 rounded-lg"
                      />
                      <input
                      type="password"
                      placeholder="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="border p-2 rounded-lg"
                      />
                      <button
                          type="submit"
                          className="bg-blue-500 font-nunito text-white p-2 rounded-lg mb-12">
                      login
                      </button>
                      {/* ny bruger? */}
                      <div className="flex justify-center">
                          <button
                              className="bg-rose-300 w-1/2 mx-auto font-nunito text-white p-2 rounded-lg"
                              onClick={() => setIsCreatingUser(true)}
                          >
                              ny bruger?
                          </button>
                      </div>
                  </form>
              )}
          </div>
        </div>
      </div>
    </div>
  );
}